class EventBus {
    listeners = {};
    on(event, cb) {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event].push(cb);
    }
    off(event, cb) {
        this.listeners[event] = (this.listeners[event] || []).filter(l => l !== cb);
    }
    emit(event, data) {
        (this.listeners[event] || []).forEach(fn => fn(data));
    }
}
export default new EventBus();